import axios from 'axios'
import { loginreq, req, req1, req2 } from './axiosFun'

export const login = (params) => {
    return loginreq('post', '/system/auth/login', params)
}
// 获取用户菜单
export const menu = (params) => {
    return axios
        .get('/api/menu?&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}
// 退出接口

export const loginout = () => {
    return axios
        .delete('/api/login?&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}
/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => {
    return req('post', '/api/User/list', params)
}
// 用户管理-保存（添加编辑）
export const userSave = (params) => {
    return req('post', '/api/User/save', params)
}
// 用户管理-删除用户
export const userDelete = (params) => {
    return axios
        .delete('/api/User/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}
// 用户管理-重置密码
export const userPwd = (params) => {
    return req('post', '/api/User/pwd', params)
}
// 用户管理-修改状态
export const userLock = (params) => {
    return axios.get(
        '/api/User/lock?userId=' +
            params.userId +
            '&lock=' +
            params.lock +
            '&token=' +
            localStorage.getItem('logintoken')
    )
}
// 用户管理-数据权限
export const UserDeptTree = (params) => {
    return axios.get(
        '/api/UserDept/tree/' + params + '?token=' + localStorage.getItem('logintoken')
    )
}
// 用户管理-数据权限保存
export const UserDeptSave = (params) => {
    return req('post', '/api/UserDept/save', params)
}
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => {
    return axios.get(
        '/api/UserDept/deptTree/' + params + '?token=' + localStorage.getItem('logintoken')
    )
}
// 用户管理-保存部门设置
export const UserChangeDept = (params) => {
    return req('post', '/api/User/change/dept', params)
}
// 用户管理-用户下线
export const userExpireToken = (params) => {
    return req('get', '/api/User/expireToken/' + params, {})
}
// 用户管理-刷新缓存
export const userFlashCache = (params) => {
    return req('get', '/api/User/flashCache/' + params, {})
}

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => {
    return req('post', '/api/Module/list')
}
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => {
    return axios.get('/api/Module/get/' + params + '?token=' + localStorage.getItem('logintoken'))
}
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => {
    return req('post', '/api/Module/nodes', params)
}
// 菜单管理-修改菜单
export const ModuleSave = (params) => {
    return req('post', '/api/Module/save', params)
}
// 菜单管理-删除菜单
export const ModuleDelete = (params) => {
    return axios
        .delete('/api/Module/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => {
    return req('post', '/api/Role/list', params)
}
// 角色管理-保存（添加编辑）
export const roleSave = (params) => {
    return req('post', '/api/Role/save', params)
}
// 角色管理-删除角色
export const roleDelete = (params) => {
    return axios
        .delete('/api/Role/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => {
    return axios.get(
        '/api/RoleRight/tree/' + params + '?token=' + localStorage.getItem('logintoken')
    )
}
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => {
    return req('post', '/api/RoleRight/save', params)
}

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => {
    return req('post', '/api/Dept/list', params)
}
// 公司管理-保存（添加编辑）
export const deptSave = (params) => {
    return req('post', '/api/Dept/save', params)
}
// 公司管理-删除公司
export const deptDelete = (params) => {
    return axios
        .get('/api/Dept/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => {
    return req('post', '/api/Variable/list', params)
}
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => {
    return req('post', '/api/Variable/save', params)
}
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => {
    return axios
        .delete(
            '/api/Variable/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken')
        )
        .then((res) => res.data)
}

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => {
    return req('post', '/api/Permission/list', params)
}
// 权限管理-保存权限
export const ermissionSave = (params) => {
    return req('post', '/api/Permission/save', params)
}
// 权限管理-删除权限
export const ermissionDelete = (params) => {
    return axios
        .delete(
            '/api/Permission/delete?ids=' + params + '&token=' + localStorage.getItem('logintoken')
        )
        .then((res) => res.data)
}
// 权限管理-获取权限
export const roleDropDown = () => {
    return axios
        .get('/api/Role/dropDown/all?&token=' + localStorage.getItem('logintoken'))
        .then((res) => res.data)
}
// 权限管理-配置权限
export const RolePermission = (params) => {
    return req('post', '/api/RolePermission/save', params)
}

// 更改密码接口
export const editPassword = (params) => {
    return req(
        'get',
        '/editPassword?userId=' +
            params.userId +
            '&old_password=' +
            params.old_password +
            '&new_password=' +
            params.new_password,
        params
    )
}
//地图撒点
export const mapDataLngLat = (object) => {
    return req('get', '/fireMap/mapDataLngLat?object=' + object, null)
}

//地图撒点
export const mapDataLngLatMap = (object) => {
    return req('get', '/fireMap/mapDataLngLat?object=' + object, null)
}
//地图弹窗项目数据
export const selectTCProjectData = (projectId) => {
    return req('get', '/fireMap/selectTCProjectData?projectId=' + projectId, null)
}

//片区列表
export const getChargeZoneList = (params) => {
    return req1('get', '/admin-api/charge/zone/page', params)
}
//简单分页
export const getChargeZonebriefPageList = (params) => {
    return req1('get', '/admin-api/charge/zone/briefPage', params)
}
//简单分页片区人员
export const getChargeZonebriefPageListPerson = (params) => {
    return req1('get', '/admin-api/charge/zone/briefPage', params)
}
//获得已分配的片区
export const getChargeZonePerson = (params) => {
    return req1('get', '/admin-api/charge/zone/briefPage', params)
}
//删除已绑定的片区-单个
export const deletepermissionArea = (ids) => {
    return req1('delete', '/admin-api/charge/zone/delete?id=' + ids, null)
}
//删除已绑定的片区-多个
export const deletepermissionAreas = (ids) => {
    return req1('delete', '/admin-api/system/user-permission/delete?ids=' + ids, null)
}
//新增片区
export const createChargeZone = (params) => {
    return req1('post', '/admin-api/charge/zone/create', params)
}
//片区编辑
export const updateChargeZone = (params) => {
    return req1('put', '/admin-api/charge/zone/update', params)
}
//片区删除
export const deleteChargeZone = (id) => {
    return req1('delete', '/admin-api/charge/zone/delete?id=' + id, null)
}
//获取当个片区
export const getChargeZone = (id) => {
    return req1('get', '/admin-api/charge/zone/get', { id })
}
export const getChargeStationList1 = (params) => {
    return req1('get', '/admin-api/charge/station/page', params)
}

//查找区域
export const getNextLevelAreaCodeList = (params) => {
    return req1('get', '/admin-api/wh/area-code/getNextLevelAreaCodeList', params)
}
//获得单个区域
export const getAreaCode = (id) => {
    return req1('get', '/admin-api/wh/area-code/get', { id })
}

//全部订单列表
export const getChargeOrderList = (params) => {
    return req1('get', '/admin-api/charge/charging-order/page', params)
}

//获取订单列表多的
export const getChargeOrderListMore = (params) => {
    return req1('get', '/admin-api/charge/charging-order/page', params)
}

//删除订单
export const deleteChargeOrder = (id) => {
    return req1('delete', '/admin-api/charge/charging-order/delete?id=' + id, null)
}
//订单退款
export const refundChargeOrder = (params) => {
    return req1('post', '/admin-api/charge/charging-order/refund', params)
}
//订单退款(异常)
export const abnormalRefundOrder = (params) => {
    return req1('post', '/admin-api/charge/charging-order/abnormalRefund', params)
}
//结束充电
export const closeChargeOrder = (params) => {
    return req1('post', '/admin-api/charge/charging-order/close', params)
}
//异常订单
export const getChargeAbnormalOrderList = (params) => {
    return req1('get', '/admin-api/charge/charging-order/abnormalPage', params)
}
//异常充电中的订单
export const getChargingAbnormalOrderList = (params) => {
    return req1('get', '/admin-api/charge/charging-order/abnormalChargingPage', params)
}
//获取单个异常中的订单
export const getAbnormalChargingDetail = (id) => {
    return req1('get', '/admin-api/charge/charging-order/getAbnormalChargingDetail', { id })
}
//更改规则
export const setChargeRule = (setChargeRuleId, params) => {
    return req1(
        'post',
        '/admin-api/charge/pile-device/setChargeRule?chargeRuleId=' + setChargeRuleId,
        params
    )
}

//批量格式化中充设备
export const formatDevice = (params) => {
    return req1('post', '/admin-api/charge/pile-device/formatDevice', params)
}

//获取社交用户
export const getSocialUserList = (params) => {
    return req1('get', '/admin-api/system/social-user/page', params)
}

//获取白名单
export const getUserWhiteListList = (params) => {
    return req1('get', '/admin-api/charge/user-white-list/page', params)
}
//新增白名单
export const createUserWhite = (params) => {
    return req1('post', '/admin-api/charge/user-white-list/create', params)
}
//删除白名单
export const deleteUserWhite = (id) => {
    return req1('delete', '/admin-api/charge/user-white-list/delete?id=' + id, null)
}

//充电站多的
export const getChargeStationListMore = (params) => {
    return req1('get', '/admin-api/charge/station/page', params)
}
//充电站
export const getChargeStationList = (params) => {
    return req1('get', '/admin-api/charge/station/page', params)
}

//简单充电站
export const getChargePileStationListEase = (params) => {
    return req1('get', '/admin-api/charge/station/page', params)
}

//新增充电站
export const createChargeStation = (params) => {
    return req1('post', '/admin-api/charge/station/create', params)
}
//编辑充电站
export const updateChargeStation = (params) => {
    return req1('put', '/admin-api/charge/station/update', params)
}
//删除充电站
export const deleteChargeStation = (id) => {
    return req1('delete', '/admin-api/charge/station/delete?id=' + id, null)
}

//获取单个充电站
export const getChargeStation = (id) => {
    return req1('get', '/admin-api/charge/station/get', { id })
}
//

export const getOperateMenu = (params) => {
    return req1('get', '/admin-api/system/menu/list-all-simple-operate', params)
}
//分账账号分页
export const getClearingAccountList = (params) => {
    return req1('get', '/admin-api/pay/clearing-account/page', params)
}
//分账账号分页（人员）
export const getClearingAccountListPerson = (params) => {
    return req1('get', '/admin-api/pay/clearing-account/page', params)
}
//新增分账账户
export const createClearingAccount = (params) => {
    return req1('post', '/admin-api/pay/clearing-account/create', params)
}
//编辑分账账户
export const updateClearingAccount = (params) => {
    return req1('put', '/admin-api/pay/clearing-account/update', params)
}
//删除分账账户
export const deleteClearingAccount = (id) => {
    return req1('delete', '/admin-api/pay/clearing-account/delete?id=' + id, null)
}

//获取单个分账账号
export const getClearingAccount = (id) => {
    return req1('get', '/admin-api/pay/clearing-account/get', { id })
}
//入驻分账账户
export const createClearingSettled = (params) => {
    return req1('post', '/admin-api/pay/clearing-account/settled', params)
}

//分账模板分页
export const getClearingConfigList = (params) => {
    return req1('get', '/admin-api/pay/clearing-config/page', params)
}
//简单分账模板分页
export const getClearingAccountBriefPage = (params) => {
    return req1('get', '/admin-api/pay/clearing-config/page', params)
}
//新增分账模板
export const createClearingConfig = (params) => {
    return req1('post', '/admin-api/pay/clearing-config/create', params)
}
//编辑分账模板
export const updateClearingConfig = (params) => {
    return req1('put', '/admin-api/pay/clearing-config/update', params)
}
//删除分账模板
export const deleteClearingConfig = (id) => {
    return req1('delete', '/admin-api/pay/clearing-config/delete?id=' + id, null)
}
//获取单个分账模板
export const getClearingConfig = (id) => {
    return req1('get', '/admin-api/pay/clearing-config/get', { id })
}
//获取分账模板关联设备
export const clearingConfigDevicePage = (params) => {
    return req1('get', '/admin-api/charge/pile-device/clearingConfigDevicePage', params)
}

//查看人员下的分账人员
// export const getChargeChargingeRuleList = (params) => {
//   return req1("get", "/admin-api/charge/charging-rule/page?name=" + params.name +"&pageNo=" + params.pageNo + "&pageSize=" + params.pageSize+ "&independently=" + params.independently, params)
// };

//计费模板分页
export const getChargeChargingeRuleList = (params) => {
    return req1('get', '/admin-api/charge/charging-rule/page', params)
}
//新增计费模板
export const createChargChargingeRule = (params) => {
    return req1('post', '/admin-api/charge/charging-rule/create', params)
}
//编辑计费模板
export const updateChargeChargingeRule = (params) => {
    return req1('put', '/admin-api/charge/charging-rule/update', params)
}
//删除计费模板
export const deleteChargeChargingeRule = (id) => {
    return req1('delete', '/admin-api/charge/charging-rule/delete?id=' + id, null)
}
//获取当个计费
export const getChargChargingeRule = (id) => {
    return req1('get', '/admin-api/charge/charging-rule/get', { id })
}
// 复制计费模板
export const copyChargChargingeRule = (id) => {
    return req1('post', '/admin-api/charge/charging-rule/copy', { id })
}

//设备列表
export const getChargePileDeviceList = (params) => {
    return req1('get', '/admin-api/charge/pile-device/page', params)
}
//设备列表(是否分配)
export const getUnallocatedPileDeviceList = (params) => {
    return req1('get', '/admin-api/charge/pile-device/unallocatedPileDevicePage', params)
}
// 分配分账账户和片区
export const createTenantPermission = (params) => {
    return req1('post', '/admin-api/system/user-permission/create', params)
}

export const getChargePileDeviceListEase = (params) => {
    return req1('get', '/admin-api/charge/pile-device/page', params)
}

//新增设备
export const createChargePileDevice = (params) => {
    return req1('post', '/admin-api/charge/pile-device/create', params)
}
//编辑设备
export const updateChargePileDevice = (params) => {
    return req1('put', '/admin-api/charge/pile-device/update', params)
}
//删除设备
export const deleteChargePileDevice = (id) => {
    return req1('delete', '/admin-api/charge/pile-device/delete', { id })
}
//获得设备插口状态
export const getPlugInfo = (id) => {
    return req1('get', '/admin-api/charge/pile-device/getPlugInfo', { id })
}
//获得简单设备分页
export const getChargePileDevicbriefPage = (params) => {
    return req1('get', '/admin-api/charge/pile-device/page', params)
}
//充电站详情获得设备分页
export const getChargeStationDevicbriefPage = (params) => {
    return req1('get', '/admin-api/charge/pile-device/page', params)
}
//获得单个设备
export const getChargePileDevice = (id) => {
    return req1('get', '/admin-api/charge/pile-device/get', { id })
}

//扫设备码获取待添加设备信息
export const scanDeviceQrCode = (params) => {
    return req1('post', '/admin-api/charge/pile-device/scan', params)
}

//获取设备实时参数
export const getChargePileDeviceCurrentParams = (params) => {
    return req1('post', '/admin-api/charge/pile-device/currentParams', params)
}

//订单列表查询设备
export const getChargePileDeviceOrder = (params) => {
    return req1('get', '/admin-api/charge/pile-device/page', params)
}

//更改个人密码
export const editPasswordCD = (params) => {
    return req1('put', '/admin-api/system/user/profile/update-password', params)
}

//重置用户密码
export const updatePasswordCD = (params) => {
    return req1('put', '/admin-api/system/auth/reset-password', params)
}

//电表列表
export const getChargeElectricityMeter = (params) => {
    return req1('get', '/admin-api/charge/electricity-meter/page', params)
}
//新增电表
export const createElectricityMeter = (params) => {
    return req1('post', '/admin-api/charge/electricity-meter/create', params)
}
//编辑电表
export const updateElectricityMeter = (params) => {
    return req1('put', '/admin-api/charge/electricity-meter/update', params)
}
//删除电表
export const deleteElectricityMeter = (id) => {
    return req1('delete', '/admin-api/charge/electricity-meter/delete?id=' + id, null)
}
//获取单个电表
export const getElectricityMeter = (id) => {
    return req1('get', '/admin-api/charge/electricity-meter/get', { id })
}

//实体卡列表
export const getCardPage = (params) => {
    return req1('get', '/admin-api/charge/card/page', params)
}
//新增实体卡
export const createCard = (params) => {
    return req1('post', '/admin-api/charge/card/create', params)
}
//编辑实体卡
export const updateCard = (params) => {
    return req1('put', '/admin-api/charge/card/update', params)
}
//删除实体卡
export const deleteCard = (id) => {
    return req1('delete', '/admin-api/charge/card/delete?id=' + id, null)
}
//充值实体卡
export const rechargeCard = (params) => {
    return req1('put', '/admin-api/charge/card/recharge', params)
}
//扣减实体卡
export const deductCard = (params) => {
    return req1('put', '/admin-api/charge/card/deduct', params)
}
//获取单个实体卡
export const getCard = (id) => {
    return req1('get', '/admin-api/charge/card/get', { id })
}
//消费记录
export const getCardMoneyLogPage = (params) => {
    return req1('get', '/admin-api/charge/card-money-log/page', params)
}
//绑定用户到卡片
export const bindUserCard = (params) => {
    return req1('post', '/admin-api/charge/card/bind', params)
}
//更换片区
export const changeCardZone = (params) => {
    return req1('post', '/admin-api/charge/card/change-zone', params)
}
//解绑用户
export const unbindCardUser = (cardId) => {
    return req1('post', '/admin-api/charge/card/unbind', { cardId })
}
//卡片挂失
export const reportCardLoss = (cardId) => {
    return req1('post', '/admin-api/charge/card/report-loss', { cardId })
}
//根据名称或ID模糊查询片区
export const getZoneByNameOrId = (params) => {
    return req1('get', '/admin-api/charge/zone/likeByNameOrId', params)
}
//恢复卡片
export const recoverCard = (cardId) => {
    return req1('post', '/admin-api/charge/card/recover', { cardId })
}
//获取卡片充值记录分页
export const getCardRechargePage = (params) => {
    return req1('get', '/admin-api/pay/card-recharge/page', params)
}
//获取卡片充电订单分页
export const getChargeOrderPage = (params) => {
    return req1('get', '/admin-api/charge/charging-order/page', params)
}

//使用率
export const getUsageRankPage = (params) => {
    return req1('get', '/admin-api/charge/station/getUsageRankPage', params)
}
//客单价
export const getArpuRankPage = (params) => {
    return req1('get', '/admin-api/charge/station/getArpuRankPage', params)
}
// 近七日收入排行
export const getIncomeRankPage = (params) => {
    return req1('get', '/admin-api/charge/station/getIncomeRankPage', params)
}
//获得简单充电站分页
export const getChargeStationbriefPage = (params) => {
    return req1('get', '/admin-api/charge/station/page', params)
}
//获得简单计费模板分页
export const getChargeChargingRulebriefPage = (params) => {
    return req1('get', '/admin-api/charge/charging-rule/page', params)
}
//字典查询
export const getDictDataPage = (params) => {
    params.status = 0
    return req1('get', '/admin-api/system/dict-data/page', params)
}
//二维码
export const downloadQrCode = (pileDeviceId) => {
    return req1('get', '/admin-api/charge/pile-device/downloadQrCode', { pileDeviceId })
}
//批量二维码
export const batchDownloadQrCode = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchDownloadQrCode', params)
}

//首页数据
export const getHomePage = (params) => {
    return req1('post', '/admin-api/charge/home/getHomePage', params)
}
// 获取用户列表（新加）
export const getUserList = (params) => {
    return req1('post', '/admin-api/charge/userr/getUserList', params)
}
// 通过用户 ID 或手机号码获取用户列表（新加）
export const getUserListByIdOrPhone = (params) => {
    return req1('post', '/admin-api/charge/userr/getUserListByIdOrPhone', params)
}
// 创建充电用户
export const createChargeUser = (params) => {
    return req1('post', '/admin-api/charge/userr/create', params)
}
export const getUserDetail = (params) => {
    return req1('post', '/admin-api/charge/userr/getUserDetail', params)
}
export const updateUserType = (params) => {
    // params = { userId: 123, isFree: true/false }
    return req1('post', '/admin-api/system/permission/update-user-type', params)
}

// 获取该用户订单列表
export const getUserOrders = (params) => {
    return req1('post', '/admin-api/charge/userr/getUserOrders', params)
}
//统计
export const getIncomeStatRecord = (params) => {
    return req1('get', '/admin-api/charge/income-stat-record/data', params)
}

//获取订单详情
export const getChargingOrderDetail = (id) => {
    return req1('get', '/admin-api/charge/charging-order/getDetail', { id })
}

//设置充电桩参数
export const setChargeParams = (params) => {
    return req1('post', '/admin-api/charge/pile-device/setChargeParams', params)
}
//查询充电桩参数
export const queryParam = (id) => {
    return req1('post', '/admin-api/charge/pile-device/queryParam?id=' + id, null)
}

//下发充电指令
export const controlChargeTask = (params, chargeBrandType, chargeDeviceType) => {
    return req1(
        'post',
        `/admin-api/charge/pile-device/controlChargeTask?chargeBrandType=${chargeBrandType}&chargeDeviceType=${chargeDeviceType}`,
        params
    )
}

//更新端口状态
export const updatePlugStatus = (params, chargeBrandType, chargeDeviceType) => {
    return req1(
        'post',
        `/admin-api/charge/pile-device/updatePlugStatus?chargeBrandType=${chargeBrandType}&chargeDeviceType=${chargeDeviceType}`,
        params
    )
}

//用户反馈
export const getfeedbackPage = (params) => {
    return req1('get', '/admin-api/charge/feedback/page', params)
}
//回复
export const updateopinion = (params) => {
    return req1('put', '/admin-api/charge/feedback/reply', params)
}
//删除
export const deleteOpinion = (id) => {
    return req1('delete', '/admin-api/charge/feedback/delete?id=' + id, null)
}

//菜单
export const getMenuList = (params) => {
    return req1('get', '/admin-api/system/menu/list', params)
}
export const listMenu = (params) => {
    return req1('get', '/admin-api/system/menu/list', params)
}
export const addMenu = (params) => {
    return req1('post', '/admin-api/system/menu/create', params)
}
export const updateMenu = (params) => {
    return req1('put', '/admin-api/system/menu/update', params)
}
export const delMenu = (id) => {
    return req1('delete', '/admin-api/system/menu/delete?id=' + id)
}
export const getMenu = (id) => {
    return req1('get', '/admin-api/system/menu/get', { id })
}

//分配权限
export const assignRoleMenu = (params) => {
    return req1('post', '/admin-api/system/permission/assign-role-menu', params)
}

//角色管理获取角色
export const getRolePage = (params) => {
    return req1('get', '/admin-api/system/role/page', params)
}
//状态编辑
export const updateJurisdictionpoint = (params) => {
    return req1('put', '/admin-api/system/role/update-status', params)
}
//新增角色
export const createRolepoint = (params) => {
    return req1('post', '/admin-api/system/role/create', params)
}
//车场编辑
export const updatRolepoint = (params) => {
    return req1('put', '/admin-api/system/role/update', params)
}
//车场删除
export const deleteRolepoint = (id) => {
    return req1('delete', '/admin-api/system/role/delete?id=' + id, null)
}

//获取菜单权限列表
export const getmenuPage = (moduleType) => {
    return req1('get', '/admin-api/system/menu/list-all-simple', { moduleType })
}
//获取角色权限列表
export function listRoleMenus(roleId) {
    return req1('get', '/admin-api/system/permission/list-role-menus', { roleId })
}
//获取用户权限列表
export function listUserMenus(userId) {
    return req1('get', '/admin-api/system/permission/list-user-menus', { userId })
}
//赋予用户权限
export const assigUserMenu = (params) => {
    return req1('post', '/admin-api/system/permission/assign-user-menu', params)
}

export const getAllPersonPage = (params) => {
    return req1('get', '/admin-api/system/user/page', params)
}
//获取简单工作人员列表
export const getAllPersonPageJD = (params) => {
    return req1('get', '/admin-api/system/user/page', params)
}
//获取角色
export const getsimplePage = (params) => {
    return req1('get', '/admin-api/system/role/simple-list', params)
}
//获取单个人员角色
export const getPersonRole = (params) => {
    return req1('get', '/admin-api/system/permission/list-user-roles', params)
}
//修改人员角色
export const updatePersonRole = (params) => {
    return req1('post', '/admin-api/system/permission/assign-user-role', params)
}
//获取岗位编号(身份)
export const getSystemPage = (params) => {
    return req1('get', '/admin-api/system/post/page', params)
}
//获取部门
export const getDeptPage = (params) => {
    return req1('get', '/admin-api/system/dept/list', params)
}
export const createPerson = (params) => {
    return req1('post', '/admin-api/system/user/create', params)
}
//修改人员
export const updatePersonRecords = (params) => {
    return req1('put', '/admin-api/system/user/update', params)
}
//删除人员
export const deletePersonRecords = (id) => {
    return req1('delete', '/admin-api/system/user/delete?id=' + id, null)
}

//运营商资料
export const getOperateAccount = (params) => {
    return req1('get', '/admin-api/pay/clearing-account/getOperateAccount', params)
}
//支行号
export const getBranchCodePage = (params) => {
    return req1('get', '/admin-api/pay/branch-code/page', params)
}
//设置运营商-片区
export const setOperateIdZone = (id, params) => {
    return req1('post', '/admin-api/charge/zone/setOperateId?operateId=' + id, params)
}
//设置运营商-充电站
export const setOperateIdstation = (id, params) => {
    return req1('post', '/admin-api/charge/station/setOperateId?operateId=' + id, params)
}
//设置运营商-设备
export const setOperateIdPileDevice = (id, params) => {
    return req1('post', '/admin-api/charge/pile-device/setOperateId?operateId=' + id, params)
}
//查询运营商角色分页
export const pageWithRoleUser = (params) => {
    return req1('get', '/admin-api/system/user/pageWithRole', params)
}
//设置分账规则-设备
export const setClearingConfigId = (id, params) => {
    return req1(
        'post',
        '/admin-api/charge/pile-device/setClearingConfigId?clearingConfigId=' + id,
        params
    )
}
//批量设置分账规则-设备
export const setChargePileDeviceClearingConfig = (id, params) => {
    return req1(
        'post',
        '/admin-api/charge/pile-device/setClearingConfigId?clearingConfigId=' + id,
        params
    )
}
//批量设置虚拟卡支付
export const setVirtualCardPay = (virtualCardPay, params) => {
    return req1(
        'post',
        '/admin-api/charge/pile-device/setVirtualCardPay?virtualCardPay=' + virtualCardPay,
        params
    )
}

//分账账户结算单
export const getClearingSettleList = (params) => {
    return req1('get', '/admin-api/pay/clearing-settle-order/page', params)
}
//分账统计汇总
export const getClearingStatRecordList = (params) => {
    return req1('get', '/admin-api/pay/clearing-stat-record/page', params)
}
export const clearingSettleOrder = (id) => {
    return req1('post', '/admin-api/pay/order/clearingSettleOrder?settleOrderId=' + id, null)
}
//分账明细-交易订单
export const getAccountOrderPage = (params) => {
    return req1('get', '/admin-api/charge/charging-order/accountOrderPage', params)
}
//提现交易
export const querySettlementQuery = (params) => {
    return req1('get', '/admin-api/pay/clearing-settle-order/querySettlementQuery', params)
}
//获得账户关联设备
export const accountDevicePage = (params) => {
    return req1('get', '/admin-api/charge/pile-device/accountDevicePage', params)
}
//查询账户余额
export const getMerchantBalance = (huifuId) => {
    return req1('get', '/admin-api/pay/clearing-settle-order/getMerchantBalance', { huifuId })
}
//分账汇总
export const getclearingStatRecord = (params) => {
    return req1('get', '/admin-api/pay/clearing-stat-record/page', params)
}
//分账关联人员
export const getUserAccount = (params) => {
    return req1('get', '/admin-api/system/user-account/page', params)
}
//新增关联分账账户
export const createUserAccount = (params) => {
    return req1('post', '/admin-api/system/user-account/create', params)
}
//删除关联分账账户
export const deleteUserAccount = (id) => {
    return req1('delete', '/admin-api/system/user-account/delete?ids=' + id, null)
}
// 获取顶部汇总数据
export const getDataSummary = (params) => {
    return req1('get', '/admin-api/charge/datasum/summary', params)
}

// 获取汇总表格数据
export const getSummaryList = (data) => req1('post', '/admin-api/charge/datasum/summary-list', data)
export const getDetailList = (data) => req1('post', '/admin-api/charge/datasum/detail-list', data)

//卡充值记录汇总
export const geTCardRecord = (params) => {
    return req1('get', '/admin-api/pay/card-recharge-stat-record/page', params)
}
//卡充值记录详单
export const getCardRecharge = (params) => {
    return req1('get', '/admin-api/pay/card-recharge/page', params)
}
//卡充值记录详单
export const getCardRecharge2 = (params) => {
    return req1('get', '/admin-api/pay/card-recharge/page', params)
}

// 充值订单退款
export const refundCardRecharge = (params) => {
    return req1('post', '/admin-api/pay/card-recharge/refund', params)
}

// 导入设备 Excel
export function importPileDeviceExcel(data) {
    return req1('post', '/admin-api/charge/pile-device/import-excel', data, true)
}

// 批量手动导入设备基本信息
export const batchManualImportBasic = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchManualImportBasic', params)
}

// 批量设置虚拟卡支付
export const batchUpdateVirtualCardPay = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchUpdateVirtualCardPay', params)
}

// 获取用户已分配片区列表
export const getUserZoneList = (userId) => {
    return req1('get', '/admin-api/system/user/list-zones', { userId })
}

// 给用户分配片区（全量覆盖）
export const assignUserZones = (params) => {
    return req1('post', '/admin-api/system/user/assign-zones', params)
}

// 获取设备指令日志列表
export const getDeviceCommandLogPage = (params) => {
    return req1('get', '/admin-api/charge/iot-device-command-log/page', params)
}

// 批量设备远程升级(0x41)
export const batchOtaUpgrade = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchOtaUpgrade', params)
}

// 批量修改设备服务器地址和端口(0x44)
export const batchModifyServerAddress = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchModifyServerAddress', params)
}

// 批量查询设备软件版本(0x2b)
export const batchReadSoftwareVersion = (params) => {
    return req1('post', '/admin-api/charge/pile-device/batchReadSoftwareVersion', params)
}



// WEBPACK FOOTER //
// ./src/api/userMG.js